module.exports = __webpack_public_path__ + "img/511.connection_problem.9a3721d4.svg";